module.exports = __webpack_public_path__ + "img/Boyner.72ccb655.png";